import React, { useEffect, useState } from "react";
import { Avatar, Box, Button, Card, CardContent, Container, Divider, FormControl, Grid, Grid2, InputLabel, MenuItem, Modal, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from "@mui/material";
import Layout from "./Layout";
import GroupIcon from '@mui/icons-material/Group';
import LeadsImg from '../images/Leads.png'
import EligibleLeadsImg from '../images/Eligible.png'
import IneligibleLeadsImg from '../images/Ineligible.png'
import AssignedImg from '../images/Assigned2.png'
import { DataGrid, GridToolbar, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import { DropzoneDialog } from "mui-file-dropzone";
import uploadCompletedImg from '../images/UploadCompleted.png'
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { formatCurrency } from "../helpers/formatter";
import moment from "moment";
import { getAllLeads } from "../actions/leadsAction";
import { leadStatus } from "../helpers/status";
import { useNavigate } from "react-router";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InfoIcon from '@mui/icons-material/Info';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoneIcon from '@mui/icons-material/Done';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { pathOr } from "ramda";


const AssignmentLogs = () => {
  const { leads } = useSelector(state => state.Leads)
  const [value, setValue] = React.useState(0);
  const [currentStep, setcurrentStep] = React.useState('');
  const [filterLeads, setfilterLeads] = React.useState([]);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const STATUS_OPTIONS = ['SMS Sent', 'E-sign Completed', 'Signed Document Received ', 'Documents Verified', 'Assignment Copy Uploaded'];

const StyledChip = styled(Chip)(({ theme }) => ({
  justifyContent: 'left',
  '& .icon': {
    color: 'inherit',
  },
  '&.Open': {
    color: (theme.vars || theme).palette.info.dark,
    border: `1px solid ${(theme.vars || theme).palette.info.main}`,
  },
  '&.Filled': {
    color: (theme.vars || theme).palette.success.dark,
    border: `1px solid ${(theme.vars || theme).palette.success.main}`,
  },
  '&.PartiallyFilled': {
    color: (theme.vars || theme).palette.warning.dark,
    border: `1px solid ${(theme.vars || theme).palette.warning.main}`,
  },
  '&.Rejected': {
    color: (theme.vars || theme).palette.error.dark,
    border: `1px solid ${(theme.vars || theme).palette.error.main}`,
  },
}));
  
  const Status = React.memo((props) => {
  const { status } = props;

  let icon = null;
  if (status === 'Rejected') {
    icon = <ReportProblemIcon className="icon" />;
  } else if (status === 'Open') {
    icon = <InfoIcon className="icon" />;
  } else if (status === 'PartiallyFilled') {
    icon = <AutorenewIcon className="icon" />;
  } else if (status === 'Filled') {
    icon = <DoneIcon className="icon" />;
  }

  let label = status;
  if (status === 'PartiallyFilled') {
    label = 'Partially Filled';
  }

  return (
    <StyledChip
      className={status}
      icon={icon}
      size="small"
      label={label}
      variant="outlined"
    />
  );
});

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    dispatch(getAllLeads())
}, []);
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }



  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          size="small"
          style={{ marginLeft: 16, background: '#4DA235', color: '#fff' }}
          onClick={() => {
            navigate('/viewleads/'+params.row.id)
          }}
        >
          View
        </Button>
      </strong>
    )
  }
  const cancelledLeads = []
  const completedLeads = []
  const inProgressLeads = []



  leads.forEach((l, i) => {
    if (l.journeyStatus == 'assigned') {
      completedLeads.push({
        id: l._id,
        createdOn: moment(l.createdAt).format("DD-MM-YYYY"),
        firstName: l.policyHolderName,
        policyNumber: l.policyNumber,
        surrenderValue: `₹ ${formatCurrency(l.surrenderValue)}`,
        leadStatus: 'New Lead',
        mobileNumber: l.policyHolderMobileNumber,
        sumAssured: l.sumAssured,
        currentStep: leadStatus(l)
      })
    }
  })

  leads.forEach((l, i) => {
    if (l.journeyStatus!="" && l.journeyStatus != 'assigned' && pathOr("", ['assignments', '0', 'status'], l) !== 'rejected') {
     
      inProgressLeads.push({
        id: l._id,
        createdOn: moment(l.createdAt).format("DD-MM-YYYY"),
        firstName: l.policyHolderName,
        policyNumber: l.policyNumber,
        surrenderValue: `₹ ${formatCurrency(l.surrenderValue)}`,
        leadStatus: 'New Lead',
        mobileNumber: l.policyHolderMobileNumber,
        sumAssured: l.sumAssured,
        currentStep: leadStatus(l)
      })
    }
  })
  let tempinProgressLeads = []
  useEffect(() => {
    debugger;
    if (currentStep != "") {
      
      tempinProgressLeads = inProgressLeads.filter((a) => {
        debugger;
        return a.currentStep==currentStep
      })
      setfilterLeads(tempinProgressLeads)
    } 
    

  }, [currentStep]);
  console.log(tempinProgressLeads)
  console.log(inProgressLeads)

  leads.forEach((l, i) => {
    if (pathOr("", ['assignments', '0', 'status'], l) === 'rejected') {

      cancelledLeads.push({
        id: l._id,
        createdOn: moment(l.createdAt).format("DD-MM-YYYY"),
        firstName: l.policyHolderName,
        policyNumber: l.policyNumber,
        surrenderValue: `₹ ${formatCurrency(l.surrenderValue)}`,
        leadStatus: 'New Lead',
        mobileNumber: l.policyHolderMobileNumber,
        sumAssured: l.sumAssured,
        currentStep: leadStatus(l)
      })
    }
  })

function renderStatus(params) {
  if (params.value == null) {
    return '';
  }

  return <Status status={params.value} />;
}


  const rows = [
    { id: 1, firstName: 'Sunil Chuhan', policyNumber: "NP081300018711",mobileNumber:'9738615475', surrenderValue: '₹ 2,49,876', sumAssured: '₹ 10,00,000',createdOn:'20-12-2024',currentStep:'Open' },
    { id: 2, firstName: 'Sunil Chuhan', policyNumber: "NP081300018711",mobileNumber:'9738615475', surrenderValue: '₹ 2,49,876', sumAssured: '₹ 10,00,000',createdOn:'20-12-2024',currentStep:'In progress' },
    { id: 3, firstName: 'Sunil Chuhan', policyNumber: "NP081300018711",mobileNumber:'9738615475', surrenderValue: '₹ 2,49,876', sumAssured: '₹ 10,00,000',createdOn:'20-12-2024',currentStep:'In progress' },
    { id: 4, firstName: 'Sunil Chuhan', policyNumber: "NP081300018711",mobileNumber:'9738615475', surrenderValue: '₹ 2,49,876', sumAssured: '₹ 10,00,000',createdOn:'20-12-2024',currentStep:'In progress' },
    { id: 5, firstName: 'Sunil Chuhan', policyNumber: "NP081300018711",mobileNumber:'9738615475', surrenderValue: '₹ 2,49,876', sumAssured: '₹ 10,00,000',createdOn:'20-12-2024',currentStep:'In progress' },
  ];

  const columns = [
    { field: 'firstName', headerName: 'Name', width: 150 },
    { field: 'policyNumber', headerName: 'Policy Number', width: 150 },
    { field: 'mobileNumber', headerName: 'Mobile No.', width: 100 },
    { field: 'surrenderValue', headerName: 'Surrender Value', width: 120 },
    { field: 'sumAssured', headerName: 'Sum Assured', width: 120 },
    { field: 'createdOn', headerName: 'Date', width: 100 },
    { field: 'currentStep', headerName: 'Current Step', renderCell: renderStatus, width: 150 },
    { field: 'action', type: 'actions', headerName: 'Action', renderCell: renderDetailsButton, width: 150 },
  ];



  return (
    <>
      <Layout>
        <React.Fragment>
          <Container>
            <Grid2 container alignItems={"center"} justifyContent={'space-between'}>
              <Grid2 item>
                <Typography variant="h5" mt={2} mb={2}>{"Policy Assignment Leads"}</Typography>
              </Grid2>
              <Grid2 item sx={{marginTop:'10px'}}>
                <FormControl sx={{ width: '200px' }}  size="small">
                  <InputLabel id="demo-simple-select-label">Current Step</InputLabel>
                  <Select
                    labelId="demo-user-type-label"
                    id="demo-user-type"
                    value={currentStep}
                    label="CurrentStep"
                    onChange={(event) => {
                      setcurrentStep(event.target.value);
                    }}
                  >
                    <MenuItem value={''}>Select</MenuItem>
                    <MenuItem value={'SMS Sent'}>SMS Sent</MenuItem>
                    <MenuItem value={'eSign Completed'}>E-sign Completed</MenuItem>
                    <MenuItem value={'Money Disbursed'}>Money Disbursed</MenuItem>
                    <MenuItem value={'Signed Document Verified'}>Signed Document Verified</MenuItem>
                    <MenuItem value={'Assignment Copy Uploaded'}>Assignment Copy Uploaded</MenuItem>
                  </Select>
                </FormControl>
              </Grid2>
            </Grid2>

            <Box sx={{ width: '100%' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label={`In progress -  ${inProgressLeads.length}`} {...a11yProps(0)} />
                  <Tab label={`Completed  -  ${completedLeads.length}`} {...a11yProps(1)} />
                  <Tab label={`Rejected  -  ${cancelledLeads.length}`} {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Paper>
                  <DataGrid rows={currentStep==""?inProgressLeads:filterLeads} columns={columns} slots={{ toolbar: GridToolbar }}
                  slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
                  />
                </Paper>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <Paper>
                  <DataGrid rows={completedLeads} columns={columns} slots={{ toolbar: GridToolbar }} />
                </Paper>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <Paper>
                  <DataGrid rows={cancelledLeads} columns={columns} slots={{ toolbar: GridToolbar }} />
                </Paper>
              </CustomTabPanel>
            </Box>



          </Container>
        </React.Fragment>
      </Layout>
    </>
  )
}

export default AssignmentLogs